import { useEffect, useRef } from 'react'

import { type EventProperties, useTrackCallback } from '@/lib/analytics/events'

import { SEARCH_TRACKING_DELAY_MS } from './consts'

type TrackCommentSearchInput = {
  query: string
  resultCount: number
  threadCount: number
  trackingProps: EventProperties
}

export const useTrackCommentSearch = ({
  query,
  resultCount,
  threadCount,
  trackingProps,
}: TrackCommentSearchInput) => {
  const trackSearchUsed = useTrackCallback('assessment.comment.search.used')

  const countsRef = useRef({ resultCount, threadCount })
  useEffect(() => {
    countsRef.current = { resultCount, threadCount }
  }, [resultCount, threadCount])

  useEffect(() => {
    const timer = query
      ? setTimeout(
          () =>
            trackSearchUsed({
              ...trackingProps,
              query_length: query.length,
              result_count: countsRef.current.resultCount,
              thread_count: countsRef.current.threadCount,
            }),
          SEARCH_TRACKING_DELAY_MS,
        )
      : undefined
    return () => clearTimeout(timer)
  }, [query, trackingProps, trackSearchUsed])
}
